export enum Sort {
    asc = 1,
    desc = 2,
}
